import React, { Component } from 'react';

import isEqual from 'lodash/isEqual';

import Tooltip from '@atlaskit/tooltip';

import { Label } from '@qality/common-components';
import {
  ProjectSelectOption,
  ProjectSelectOptions,
} from '@qality/common-model';
import { StorageOfUniqueComponents } from '@qality/common-service';
import { ProjectsAvailabilityContext } from '@qality/common-state/src/ProjectsAvailabilityContext';
import { Utils } from '@qality/common-utils';

import './_project-select.scss';

type OnChangeValue =
  | [{ name: 'project'; value: string }]
  | ProjectSelectOption
  | ProjectSelectOptions;

type Props = {
  onChange: (value: OnChangeValue) => void;
  onBlur?: (event: React.FocusEvent<HTMLElement>) => void;
  useAllOption: boolean;
  addNameOfFilter: boolean;
  classNames: string;
  isClearable?: boolean;
  isDisabled?: boolean;
  tooltip?: string;
  showLabel: boolean;
  isInvalid?: boolean;
  placeholder?: string;
  projectId?: string;
  isInModal: boolean;
  value: ProjectSelectOption | ProjectSelectOptions;
  isMulti?: boolean;
};

type State = {
  selectValue: ProjectSelectOption | ProjectSelectOptions;
};

export const ALL_PROJECTS: ProjectSelectOption = {
  label: 'All projects',
  value: 'ALL_PROJECTS',
};

export default class RecentAndMoreProjectSelect extends Component<
  Props,
  State
> {
  static defaultProps = {
    isClearable: true,
    useAllOption: true,
    addNameOfFilter: true,
    classNames: '',
    showLabel: true,
    value: null,
    placeholder: 'Search project...',
    isInModal: false,
    isMulti: false,
  };

  static contextType = ProjectsAvailabilityContext;

  constructor(props: Props) {
    super(props);

    this.state = {
      selectValue: this.props.value,
    };
  }

  componentDidUpdate(prevProps: Props): void {
    if (this.props.value && !isEqual(this.props.value, prevProps.value)) {
      this.setState({
        selectValue: this.props.value,
      });
    }
  }

  onChange = async (
    value: ProjectSelectOption | ProjectSelectOptions
  ): Promise<void> => {
    const getActualValue = () => {
      const useFallbackValue =
        this.props.useAllOption && Utils.isNilOrEmpty(value);

      if (useFallbackValue) {
        return this.props.isMulti ? [ALL_PROJECTS] : ALL_PROJECTS;
      }

      if (this.props.isMulti) {
        return value.length > 1
          ? value.filter((option) => {
              return option.value !== 'ALL_PROJECTS';
            })
          : value;
      }

      return value;
    };

    const actualValue = getActualValue();
    this.setState({
      selectValue: actualValue,
    });

    if (this.props.addNameOfFilter) {
      this.props.onChange([{ name: 'project', value: actualValue.value }]);
    } else {
      this.props.onChange(actualValue);
    }
  };

  render(): React.ReactNode {
    const RecentAndMoreProjectSelectUnique = StorageOfUniqueComponents.get(
      'RecentAndMoreProjectSelect'
    );

    return (
      <div className={this.props.classNames}>
        {this.props.showLabel && <Label text='Project' />}
        <Tooltip content={this.props.tooltip}>
          <div className='hide-focus-wrapper'>
            <RecentAndMoreProjectSelectUnique
              id='qality-project-select'
              isClearable={this.props.isClearable}
              value={this.state.selectValue}
              projectId={this.props.projectId}
              onChange={this.onChange}
              onBlur={this.props.onBlur}
              isDisabled={this.props.isDisabled}
              isInvalid={this.props.isInvalid}
              placeholder={this.props.placeholder}
              projectsAvailabilityByProjectKey={
                this.context.projectsAvailabilityByProjectKey
              }
              isInModal={this.props.isInModal}
              isMulti={this.props.isMulti}
            />
          </div>
        </Tooltip>
      </div>
    );
  }
}
